/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityProgression } from './ActivityProgression';
import {
    ActivityProgressionFromJSON,
    ActivityProgressionFromJSONTyped,
    ActivityProgressionToJSON,
    ActivityProgressionToJSONTyped,
} from './ActivityProgression';

/**
 * 
 * @export
 * @interface ClaimCheckpointResponse
 */
export interface ClaimCheckpointResponse {
    /**
     * 
     * @type {ActivityProgression}
     * @memberof ClaimCheckpointResponse
     */
    progression: ActivityProgression;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimCheckpointResponse
     */
    rewardsGranted: boolean;
}

/**
 * Check if a given object implements the ClaimCheckpointResponse interface.
 */
export function instanceOfClaimCheckpointResponse(value: object): value is ClaimCheckpointResponse {
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('rewardsGranted' in value) || value['rewardsGranted'] === undefined) return false;
    return true;
}

export function ClaimCheckpointResponseFromJSON(json: any): ClaimCheckpointResponse {
    return ClaimCheckpointResponseFromJSONTyped(json, false);
}

export function ClaimCheckpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCheckpointResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'progression': ActivityProgressionFromJSON(json['progression']),
        'rewardsGranted': json['rewardsGranted'],
    };
}

export function ClaimCheckpointResponseToJSON(json: any): ClaimCheckpointResponse {
    return ClaimCheckpointResponseToJSONTyped(json, false);
}

export function ClaimCheckpointResponseToJSONTyped(value?: ClaimCheckpointResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'progression': ActivityProgressionToJSON(value['progression']),
        'rewardsGranted': value['rewardsGranted'],
    };
}

